/**
 * Stock Chart Viewer - Application State
 */

export const state = {
    currentMode: 'STOCK', // 'STOCK' or 'CRYPTO'
    currentSymbol: null,
    currentPeriod: '1M',
    chart: null,
    candleSeries: null,
    volumeSeries: null,
    sma20Series: null,
    sma50Series: null,
    stockData: null,
    watchlist: JSON.parse(localStorage.getItem('stockWatchlist') || '["AAPL","GOOGL","MSFT","AMZN","TSLA","NVDA"]'),
    indicators: {
        sma20: false,
        sma50: false,
        rsi: false,
        macd: false,
        bb: false,
        ichimoku: false,
        stoch: false,
    },
    // Bollinger Bands Series
    bbUpperSeries: null,
    bbLowerSeries: null,

    // RSI Chart
    rsiChart: null,
    rsiSeries: null,

    // MACD Chart
    macdChart: null,
    macdSeries: null,
    macdSignalSeries: null,
    macdSignalSeries: null,
    macdHistSeries: null,

    // Ichimoku Series
    ichimokuSeries: null, // { conversion, base, spanA, spanB }

    // Stochastic Chart
    stochChart: null,
    stochSeries: null, // { k, d }
    cacheOnlyMode: JSON.parse(localStorage.getItem('cacheOnlyMode') || 'false'),
    storageMode: localStorage.getItem('storageMode') || 'localStorage',
    comparisonSeries: [], // Array of { symbol, series, color }
    isDrawingMode: false,
    drawings: [], // Array of PriceLine objects (Runtime)
    persistedDrawings: {}, // { symbol: [ { type, price, timestamp } ] }

    // Portfolio Management
    portfolio: JSON.parse(localStorage.getItem('stockPortfolio') || '[]'),

    // Price Alerts
    alerts: JSON.parse(localStorage.getItem('stockAlerts') || '[]'),
    alertHistory: JSON.parse(localStorage.getItem('alertHistory') || '[]'),
};

/**
 * Persist State Logic
 */
export function saveState() {
    const persistData = {
        currentSymbol: state.currentSymbol,
        currentPeriod: state.currentPeriod,
        currentMode: state.currentMode,
        indicators: state.indicators,
        cacheOnlyMode: state.cacheOnlyMode,
        storageMode: state.storageMode,
        theme: state.theme || 'dark',
        persistedDrawings: state.persistedDrawings,
    };
    localStorage.setItem('tradeAppState', JSON.stringify(persistData));

    // Persist portfolio and alerts separately for performance
    localStorage.setItem('stockPortfolio', JSON.stringify(state.portfolio));
    localStorage.setItem('stockAlerts', JSON.stringify(state.alerts));
    localStorage.setItem('alertHistory', JSON.stringify(state.alertHistory));
}

export function loadState() {
    const saved = localStorage.getItem('tradeAppState');
    if (saved) {
        try {
            const parsed = JSON.parse(saved);
            // Merge saved state into current state
            // We verify keys to avoid corrupt data issues
            if (parsed.currentSymbol) state.currentSymbol = parsed.currentSymbol;
            if (parsed.currentPeriod) state.currentPeriod = parsed.currentPeriod;
            if (parsed.currentMode) state.currentMode = parsed.currentMode;
            if (parsed.indicators) state.indicators = { ...state.indicators, ...parsed.indicators };
            if (parsed.theme) state.theme = parsed.theme;
            if (parsed.persistedDrawings) state.persistedDrawings = parsed.persistedDrawings;
            // Portfolio and alerts are loaded from their own keys (already in state init)
        } catch (e) {
            console.warn('Failed to load state:', e);
        }
    }
}

export function resetState() {
    state.currentSymbol = null;
    state.stockData = null;
    saveState(); // Update storage
}

